// Librerías
import React, { Component } from "react";
import { connect } from "react-redux";
import * as aloharFormActions from "../../store/aloharForm/actions";
import AxiosAuth from "../../services/requestApi";
// Componentes
import Title from "./Steps/Title";
import Type from "./Steps/Type";
import Quantities from "./Steps/Quantities";
import Location from "./Steps/Location";
import Services from "./Steps/Services";
import Covid from "./Steps/Covid";
import Photos from "./Steps/Photos";
import Rules from "./Steps/Rules";
import Guests from "./Steps/Guests";
import Prices from "./Steps/Prices";
import Payment from "./Steps/Payment";
import Legal from "./Steps/Legal";
import CalendarV2 from "./Steps/CalendarV2"; // ✅ Usar el componente separado
import { withRouter } from "react-router-dom";
import { BASE_URL } from "../../Helpers";

class AloharFormEdit extends Component {
  constructor(props) {
    super(props);

    if (
      parseInt(this.props.editStep) > 15 ||
      parseInt(this.props.editStep) < 3
    ) {
      window.location.href = "/";
    }

    this.props.setStep({ step: this.props.editStep });
    this.state = {
      step: parseInt(this.props.editStep),
      id: parseInt(this.props.id),
      loading: false,
      bodyParameters: {},
      currentLang: this.props.currentLang || "es",
    };
  }

  componentWillUnmount = () => {
    // localStorage.removeItem('housingPublicProcessData')
  };

  componentDidMount = async () => {
    const step = this.state.step;
    const id = this.state.id;
    const url = `housing/public/${step - 2}/${id}`;

    this.props.housingIdSetup({ id: id });

    await AxiosAuth.get(url)
      .then((response) => {
        let bodyParameters = response.data;

        if (this.state.step === 15) {
          // ✅ CORREGIDO: Para react-big-calendar, formatear fechas correctamente
          const newBodyParameters = bodyParameters.calendar.map((calendar) => {
            // ✅ Usar las fechas del servidor directamente, pero ajustadas para react-big-calendar
            const startDate = new Date(calendar.start);
            const endDate = new Date(calendar.end);
            
            // ✅ Para react-big-calendar con eventos de día completo:
            // - start: fecha de inicio (inclusiva)
            // - end: día siguiente al final (exclusiva, como espera react-big-calendar)
            const adjustedEndDate = new Date(endDate);
            adjustedEndDate.setDate(adjustedEndDate.getDate() + 1);
            
            // ✅ Formatear fechas
            let ddStart = startDate.getDate();
            let mmStart = startDate.getMonth() + 1;
            const yyyyStart = startDate.getFullYear();

            if (ddStart < 10) ddStart = "0" + ddStart;
            if (mmStart < 10) mmStart = "0" + mmStart;

            let dd = adjustedEndDate.getDate();
            let mm = adjustedEndDate.getMonth() + 1;
            const yyyy = adjustedEndDate.getFullYear();

            if (dd < 10) dd = "0" + dd;
            if (mm < 10) mm = "0" + mm;

            return {
              start: `${yyyyStart}-${mmStart}-${ddStart}`,
              end: `${yyyy}-${mm}-${dd}`, // ✅ Día siguiente para react-big-calendar
              selectable:
                calendar.typeHousingCalendar !== "calendarImport" &&
                calendar.typeHousingCalendar !== "season" &&
                calendar.typeHousingCalendar !== "block" &&
                calendar.typeHousingCalendar !== "hold",
              amount: calendar.price, 
              backgroundColor:
                calendar.typeHousingCalendar === "calendarImport"
                  ? "rgba(255, 182, 193, .6)"
                  : calendar.typeHousingCalendar === "season"
                  ? "rgba(255, 165, 0, .6)"
                  : calendar.typeHousingCalendar === "block"
                  ? "rgba(255, 0, 0, .6)"
                  : calendar.typeHousingCalendar === "hold"
                  ? "rgba(0, 0, 255, .6)"
                  : calendar.typeHousingCalendar === "hot_sale"
                  ? "rgba(255, 78, 0, .6)"
                  : "rgba(0, 128, 0, .6)",
              borderColor:
                calendar.typeHousingCalendar === "calendarImport"
                  ? "rgba(255, 182, 193, .6)"
                  : calendar.typeHousingCalendar === "season"
                  ? "rgba(255, 165, 0, .6)"
                  : calendar.typeHousingCalendar === "block"
                  ? "rgba(255, 0, 0, .6)"
                  : calendar.typeHousingCalendar === "hold"
                  ? "rgba(0, 0, 255, .6)"
                  : calendar.typeHousingCalendar === "hot_sale"
                  ? "rgba(255, 78, 0, .6)"
                  : "rgba(0, 128, 0, .6)",
              typeHousingCalendar: calendar.typeHousingCalendar,
              // ✅ IMPORTANTE: Preservar datos originales del servidor
              originalStart: calendar.start,
              originalEnd: calendar.end,
            };
          });
          bodyParameters["calendar"] = newBodyParameters;
        }

        // Sincronizar datos con Redux
        this.syncDataWithRedux(step, bodyParameters);

        this.setState({
          bodyParameters: bodyParameters,
          loading: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.currentLang !== prevProps.currentLang) {
      this.setState({
        currentLang: this.props.currentLang,
      });
    }
  }

  showStep = () => {
    const step = this.state.step;
    const bodyParameters = this.state.bodyParameters;

    switch (step) {
      case 3:
        return (
          <Type
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 4:
        return (
          <Quantities
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 5:
        return (
          <Location
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 6:
        return (
          <Services
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 7:
        return (
          <Covid
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 8:
        return (
          <Photos
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 9:
        return (
          <Rules
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 10:
        return (
          <Guests
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 11:
        return (
          <Title
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 12:
        return (
          <Prices
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 13:
        return (
          <Payment
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 14:
        return (
          <Legal
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      case 15:
        return (
          <CalendarV2
            lenguaje={this.state.currentLang}
            bodyParameters={bodyParameters}
            modeEdit
          />
        );
      default:
        window.location.href = "/";
    }
  };

  // Sincronizar datos cargados con Redux store
  syncDataWithRedux = (step, bodyParameters) => {
    switch (step) {
      case 3:
        this.props.typeStep(bodyParameters);
        break;
      case 4:
        this.props.quantitiesStep(bodyParameters);
        break;
      case 5:
        this.props.locationStep(bodyParameters);
        break;
      case 6:
        this.props.servicesStep(bodyParameters);
        break;
      case 7:
        this.props.covidStep(bodyParameters);
        break;
      case 8:
        this.props.photosStep(bodyParameters);
        break;
      case 9:
        this.props.ruleStep(bodyParameters);
        break;
      case 10:
        this.props.guestStep(bodyParameters);
        break;
      case 11:
        this.props.titleStep(bodyParameters);
        break;
      case 12:
        this.props.priceStep(bodyParameters);
        break;
      case 13:
        this.props.paymentStep(bodyParameters);
        break;
      case 14:
        this.props.legalStep(bodyParameters);
        break;
      case 15:
        this.props.calendarStep(bodyParameters);
        break;
      default:
        break;
    }
  };

  render() {
    if (this.state.loading) {
      return this.showStep();
    } else {
      return <div>Loading...</div>;
    }
  }
}

const mapStateToProps = (reducers) => {
  return reducers.aloharFormReducer;
};

export default withRouter(
  connect(mapStateToProps, aloharFormActions)(AloharFormEdit)
);
